import { IAppState } from '@store/model';
import { createSelector } from 'reselect';

export const selectPapers = (state: IAppState) => state.papers;

export const selectPapersData = createSelector([selectPapers], (papers) => papers.records);
